module.exports = __webpack_public_path__ + "img/android.f4b85939.svg";